export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/login')) {
    return;
  }

  const token = sessionStorage.getItem('token');
  if (!token) {
    return navigateTo('/login', { replace: true });
  }

  // expira se passou 20 minutos de inatividade
  const expiresIn = sessionStorage.getItem('expiresIn');
  if (!expiresIn || $dayjs(expiresIn).diff($dayjs(), 'minute') < 0) {
    const nuxtApp = useNuxtApp();
    delete nuxtApp.payload.state['currentUser'];
    sessionStorage.removeItem('expiresIn');
    sessionStorage.removeItem('token');
    return navigateTo('/login?logout', { replace: true });
  }

  const currentUser = useState('currentUser');
  if (!currentUser.value) {
    const user: GuestInterface = await useApiFetch('api/pwa/currentuser');
    useState('currentUser', () => user);
  }

  sessionStorage.setItem(
    'expiresIn',
    $dayjs().add(useRuntimeConfig().public.expiresIn, 'minute').toISOString()
  );
});
